export default {"src":"/_next/static/media/2025-best-support.d43c0b2e.svg","height":127,"width":98,"blurWidth":0,"blurHeight":0};